import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ParametrizacaoLimites } from 'src/app/@shared/models/parametrizacao-limites.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoLimitesService {
  constructor(private http: HttpClient) { }

  listarParametrizacaoLimiteValor(): Observable<ParametrizacaoLimites[]> {
    return this.http.get<ParametrizacaoLimites[]>(`ParametrizacaoLimiteValor/Listar`, httpOptions)
  }

  editarParametrizacaoLimiteValor(tipoManifestoId: number, obj: ParametrizacaoLimites): Observable<any> {
    return this.http.put<any>(`ParametrizacaoLimiteValor/Editar/${tipoManifestoId}`, obj, httpOptions);
  }
}
